export default __webpack_public_path__ + "static/media/assetTradeIcon3.968b6a8b.webp";